<template>
  <bulk-create-accounts
    :is-loading="isLoading"
    :project-name-by-id="projectNameById"
    :created-accounts="createdAccounts"
    @create="onCreate"
    @retry="onRetry"
  />
</template>

<script>
import { API } from '@/utils/api'
import BulkCreateAccounts from '../components/BulkCreateAccounts.vue'
const BULK_CREATE_ENDPOINT = '/$v/tools/bulk_account_create.json'

export default {
  components: {
    BulkCreateAccounts,
  },

  data() {
    return {
      isLoading: false,
      createdAccounts: []
    }
  },

  computed: {
    projectNameById() {
      const projectNameById = {}
      for (const project of this.$store.state.auth.entities) {
        projectNameById[project.entity_id] = project.name
      }

      return projectNameById
    },
  },

  methods: {
    resultToFlat(result) {
      const flatAccounts = []

      for (const entity_id in result) {
        for (const {account, result, error} of result[entity_id]) {
          flatAccounts.push({
            ...account,
            entity_id,
            error,
            result,
          })
        }
      }

      return flatAccounts
    },
    onCreate({ accounts, by_entities }) {
      this.createdAccounts = []

      this.$root.$confirm(
        'Confirm',
        `Create ${accounts.length * by_entities.length} accounts for ${by_entities.length} projects (${accounts.length} accounts each)?`
      ).then(yes => {
        if (!yes) {
          return
        }

        this.isLoading = true
        return API.call(BULK_CREATE_ENDPOINT, {
          accounts,
          by_entities,
        }).then(r => {
          this.createdAccounts = this.resultToFlat(r.result)
        }).finally(() => {
          this.isLoading = false
        })
      })
    },

    onRetry({ account, entity_id }) {


      this.$root.$confirm(
        'Confirm',
        `Retry creating this account?`
      ).then(yes => {
        if (!yes) {
          return
        }

        this.isLoading = true

        return API.call(BULK_CREATE_ENDPOINT, {
          accounts: [account],
          by_entities: [entity_id],
        }).then(r => {
          const createdAccount = this.createdAccounts.find(created => created === account)
          const result = this.resultToFlat(r.result)
          if (result[0]) {
            Object.assign(createdAccount, result[0])
          }

        }).finally(() => {
          this.isLoading = false
        })
      })
    }
  }
}
</script>
